export const MAX_PRECISION_ROUND_DIGITS: Readonly<Record<string, number>> = {
  velocity: 2,
  velocity_variability: 1,
  cadence_variability: 1,
  stance_asymmetry: 1,
  double_support_asymmetry: 2,
  step_length_asymmetry: 2,
  step_length_left: 2,
  step_length_right: 2,
  step_length_diff: 2,
  single_support_left: 2,
  single_support_right: 2,
}
